import { render, staticRenderFns } from "./delete-emails.vue?vue&type=template&id=6ac5aa90&scoped=true"
import script from "./delete-emails.vue?vue&type=script&lang=js"
export * from "./delete-emails.vue?vue&type=script&lang=js"
import style0 from "./delete-emails.vue?vue&type=style&index=0&id=6ac5aa90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac5aa90",
  null
  
)

export default component.exports